import React from 'react';
import PropTypes from 'prop-types';

export const SpaceHelmet = ({ width = 48, height = 48 }) => (
  <svg width={width} height={height} viewBox="0 0 48 48" fill="none" xmlns="http://www.w3.org/2000/svg">
    <g clipPath="url(#clip0_55748_101864)">
      <path
        d="M13.3851 42.3129C15.4087 43.2553 27.9946 50.8143 38.6962 38.44C43.1545 35.2195 50.1303 22.487 44.6071 13.0718C40.3757 5.84358 31.2268 0.716461 23.8756 3.16179C-5.12861 5.7539 -0.26331 35.9116 13.3851 42.3129Z"
        fill="#F1F1F1"
      />
      <path
        d="M23.7002 6.9541C31.5942 6.95428 38.039 13.7533 38.0391 22.1982C38.0391 30.6432 31.5942 37.4422 23.7002 37.4424C15.806 37.4424 9.36133 30.6433 9.36133 22.1982C9.36134 13.7532 15.806 6.9541 23.7002 6.9541Z"
        fill="white"
        stroke="#00005A"
        strokeWidth="0.905613"
      />
      <path
        d="M24 18.4999C30.5 11.4999 15.5 19 13 15.9998C21.5 10.5 28.5 12.4999 34 15.4999C31.9753 17.8848 27.6225 19.4056 24 18.4999Z"
        stroke="url(#paint0_linear_55748_101864)"
        strokeWidth="0.905613"
      />
      <path
        d="M34.2661 15.8585C27.3231 11.3305 20.9838 10.7267 12.8333 16.1604C10.8206 19.6465 11.6258 24.6128 12.8333 28.839C17.3614 34.5745 30.3418 35.782 34.568 28.5371C35.7755 23.7072 36.1602 19.7828 34.2661 15.8585Z"
        stroke="#00005A"
        strokeWidth="0.905613"
      />
      <path
        d="M20.5 28C20.5 28 20.5 30 25.8136 28.8235"
        stroke="#00005A"
        strokeWidth="0.905613"
        strokeLinecap="round"
      />
      <path
        d="M23.7257 23.3896C23.7257 23.3896 25.235 25.8046 23.7257 25.8046"
        stroke="#00005A"
        strokeWidth="0.905613"
        strokeLinecap="round"
      />
      <ellipse cx="19.35" cy="21.75" rx="1.35" ry="1.75" fill="#00005A" />
      <ellipse cx="28.35" cy="21.75" rx="1.35" ry="1.75" fill="#00005A" />
      <path
        d="M10.1165 17.3682C10.1165 17.3682 7.4755 17.8575 7.0978 19.1794C6.49404 21.2925 6.49409 23.4056 6.79593 25.2168C7.02192 26.5729 9.81464 27.028 9.81464 27.028"
        stroke="#00005A"
        strokeWidth="0.905613"
      />
      <path
        d="M37.2849 27.0278C37.2849 27.0278 39.9259 26.5385 40.3036 25.2166C40.9073 23.1035 40.9073 20.9904 40.6054 19.1792C40.3794 17.8231 37.5867 17.368 37.5867 17.368"
        stroke="#00005A"
        strokeWidth="0.905613"
      />
      <path
        d="M12.2279 32.1597C12.2279 32.1597 8.90734 33.9709 8.60547 36.9896C12.5298 42.7252 32.1514 42.1214 38.7926 37.2915C39.3963 34.2728 34.8682 32.1597 34.8682 32.1597"
        stroke="#00005A"
        strokeWidth="0.905613"
      />
      <g clipPath="url(#clip1_55748_101864)">
        <path
          d="M5.797 40.0416C5.74492 39.8398 5.63969 39.6555 5.49227 39.5081C5.34485 39.3607 5.16062 39.2555 4.95875 39.2034L1.38 38.2806C1.31894 38.2632 1.2652 38.2265 1.22694 38.1758C1.18867 38.1252 1.16797 38.0635 1.16797 38C1.16797 37.9365 1.18867 37.8748 1.22694 37.8241C1.2652 37.7735 1.31894 37.7367 1.38 37.7194L4.95875 36.796C5.16055 36.744 5.34473 36.6388 5.49215 36.4915C5.63956 36.3442 5.74483 36.1601 5.797 35.9583L6.71983 32.3796C6.73698 32.3183 6.77372 32.2643 6.82443 32.2258C6.87515 32.1873 6.93705 32.1665 7.0007 32.1665C7.06436 32.1665 7.12626 32.1873 7.17698 32.2258C7.22769 32.2643 7.26442 32.3183 7.28158 32.3796L8.20383 35.9583C8.25591 36.1602 8.36113 36.3444 8.50855 36.4918C8.65597 36.6393 8.8402 36.7445 9.04208 36.7966L12.6208 37.7188C12.6824 37.7358 12.7366 37.7725 12.7753 37.8233C12.814 37.8741 12.8349 37.9361 12.8349 38C12.8349 38.0638 12.814 38.1259 12.7753 38.1767C12.7366 38.2275 12.6824 38.2642 12.6208 38.2811L9.04208 39.2034C8.8402 39.2555 8.65597 39.3607 8.50855 39.5081C8.36113 39.6555 8.25591 39.8398 8.20383 40.0416L7.281 43.6204C7.26384 43.6817 7.22711 43.7357 7.17639 43.7742C7.12568 43.8126 7.06377 43.8335 7.00012 43.8335C6.93647 43.8335 6.87456 43.8126 6.82385 43.7742C6.77314 43.7357 6.7364 43.6817 6.71925 43.6204L5.797 40.0416Z"
          fill="white"
        />
        <path
          d="M5.797 40.0416C5.74492 39.8398 5.63969 39.6555 5.49227 39.5081C5.34485 39.3607 5.16062 39.2555 4.95875 39.2034L1.38 38.2806C1.31894 38.2632 1.2652 38.2265 1.22694 38.1758C1.18867 38.1252 1.16797 38.0635 1.16797 38C1.16797 37.9365 1.18867 37.8748 1.22694 37.8241C1.2652 37.7735 1.31894 37.7367 1.38 37.7194L4.95875 36.796C5.16055 36.744 5.34473 36.6388 5.49215 36.4915C5.63956 36.3442 5.74483 36.1601 5.797 35.9583L6.71983 32.3796C6.73698 32.3183 6.77372 32.2643 6.82443 32.2258C6.87515 32.1873 6.93705 32.1665 7.0007 32.1665C7.06436 32.1665 7.12626 32.1873 7.17698 32.2258C7.22769 32.2643 7.26442 32.3183 7.28158 32.3796L8.20383 35.9583C8.25591 36.1602 8.36113 36.3444 8.50855 36.4918C8.65597 36.6393 8.8402 36.7445 9.04208 36.7966L12.6208 37.7188C12.6824 37.7358 12.7366 37.7725 12.7753 37.8233C12.814 37.8741 12.8349 37.9361 12.8349 38C12.8349 38.0638 12.814 38.1259 12.7753 38.1767C12.7366 38.2275 12.6824 38.2642 12.6208 38.2811L9.04208 39.2034C8.8402 39.2555 8.65597 39.3607 8.50855 39.5081C8.36113 39.6555 8.25591 39.8398 8.20383 40.0416L7.281 43.6204C7.26384 43.6817 7.22711 43.7357 7.17639 43.7742C7.12568 43.8126 7.06377 43.8335 7.00012 43.8335C6.93647 43.8335 6.87456 43.8126 6.82385 43.7742C6.77314 43.7357 6.7364 43.6817 6.71925 43.6204L5.797 40.0416Z"
          stroke="#8797AB"
          strokeWidth="1.3125"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
        <path
          d="M5.797 40.0416C5.74492 39.8398 5.63969 39.6555 5.49227 39.5081C5.34485 39.3607 5.16062 39.2555 4.95875 39.2034L1.38 38.2806C1.31894 38.2632 1.2652 38.2265 1.22694 38.1758C1.18867 38.1252 1.16797 38.0635 1.16797 38C1.16797 37.9365 1.18867 37.8748 1.22694 37.8241C1.2652 37.7735 1.31894 37.7367 1.38 37.7194L4.95875 36.796C5.16055 36.744 5.34473 36.6388 5.49215 36.4915C5.63956 36.3442 5.74483 36.1601 5.797 35.9583L6.71983 32.3796C6.73698 32.3183 6.77372 32.2643 6.82443 32.2258C6.87515 32.1873 6.93705 32.1665 7.0007 32.1665C7.06436 32.1665 7.12626 32.1873 7.17698 32.2258C7.22769 32.2643 7.26442 32.3183 7.28158 32.3796L8.20383 35.9583C8.25591 36.1602 8.36113 36.3444 8.50855 36.4918C8.65597 36.6393 8.8402 36.7445 9.04208 36.7966L12.6208 37.7188C12.6824 37.7358 12.7366 37.7725 12.7753 37.8233C12.814 37.8741 12.8349 37.9361 12.8349 38C12.8349 38.0638 12.814 38.1259 12.7753 38.1767C12.7366 38.2275 12.6824 38.2642 12.6208 38.2811L9.04208 39.2034C8.8402 39.2555 8.65597 39.3607 8.50855 39.5081C8.36113 39.6555 8.25591 39.8398 8.20383 40.0416L7.281 43.6204C7.26384 43.6817 7.22711 43.7357 7.17639 43.7742C7.12568 43.8126 7.06377 43.8335 7.00012 43.8335C6.93647 43.8335 6.87456 43.8126 6.82385 43.7742C6.77314 43.7357 6.7364 43.6817 6.71925 43.6204L5.797 40.0416Z"
          stroke="url(#paint1_linear_55748_101864)"
          strokeWidth="1.3125"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </g>
      <path
        d="M39.797 9.04165C39.7449 8.83977 39.6397 8.65554 39.4923 8.50812C39.3449 8.3607 39.1606 8.25548 38.9587 8.2034L35.38 7.28057C35.3189 7.26324 35.2652 7.22646 35.2269 7.17583C35.1887 7.12519 35.168 7.06345 35.168 6.99998C35.168 6.93651 35.1887 6.87478 35.2269 6.82414C35.2652 6.7735 35.3189 6.73673 35.38 6.7194L38.9587 5.79598C39.1605 5.74395 39.3447 5.63882 39.4921 5.49151C39.6396 5.34419 39.7448 5.16008 39.797 4.95832L40.7198 1.37957C40.737 1.31827 40.7737 1.26427 40.8244 1.2258C40.8751 1.18733 40.9371 1.1665 41.0007 1.1665C41.0644 1.1665 41.1263 1.18733 41.177 1.2258C41.2277 1.26427 41.2644 1.31827 41.2816 1.37957L42.2038 4.95832C42.2559 5.16019 42.3611 5.34442 42.5086 5.49184C42.656 5.63926 42.8402 5.74449 43.0421 5.79657L46.6208 6.71882C46.6824 6.73579 46.7366 6.77249 46.7753 6.82328C46.814 6.87407 46.8349 6.93614 46.8349 6.99998C46.8349 7.06382 46.814 7.1259 46.7753 7.17669C46.7366 7.22748 46.6824 7.26417 46.6208 7.28115L43.0421 8.2034C42.8402 8.25548 42.656 8.3607 42.5086 8.50812C42.3611 8.65554 42.2559 8.83977 42.2038 9.04165L41.281 12.6204C41.2638 12.6817 41.2271 12.7357 41.1764 12.7742C41.1257 12.8126 41.0638 12.8335 41.0001 12.8335C40.9365 12.8335 40.8746 12.8126 40.8239 12.7742C40.7731 12.7357 40.7364 12.6817 40.7192 12.6204L39.797 9.04165Z"
        stroke="#8797AB"
        strokeWidth="1.125"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
      <path
        d="M39.797 9.04165C39.7449 8.83977 39.6397 8.65554 39.4923 8.50812C39.3449 8.3607 39.1606 8.25548 38.9587 8.2034L35.38 7.28057C35.3189 7.26324 35.2652 7.22646 35.2269 7.17583C35.1887 7.12519 35.168 7.06345 35.168 6.99998C35.168 6.93651 35.1887 6.87478 35.2269 6.82414C35.2652 6.7735 35.3189 6.73673 35.38 6.7194L38.9587 5.79598C39.1605 5.74395 39.3447 5.63882 39.4921 5.49151C39.6396 5.34419 39.7448 5.16008 39.797 4.95832L40.7198 1.37957C40.737 1.31827 40.7737 1.26427 40.8244 1.2258C40.8751 1.18733 40.9371 1.1665 41.0007 1.1665C41.0644 1.1665 41.1263 1.18733 41.177 1.2258C41.2277 1.26427 41.2644 1.31827 41.2816 1.37957L42.2038 4.95832C42.2559 5.16019 42.3611 5.34442 42.5086 5.49184C42.656 5.63926 42.8402 5.74449 43.0421 5.79657L46.6208 6.71882C46.6824 6.73579 46.7366 6.77249 46.7753 6.82328C46.814 6.87407 46.8349 6.93614 46.8349 6.99998C46.8349 7.06382 46.814 7.1259 46.7753 7.17669C46.7366 7.22748 46.6824 7.26417 46.6208 7.28115L43.0421 8.2034C42.8402 8.25548 42.656 8.3607 42.5086 8.50812C42.3611 8.65554 42.2559 8.83977 42.2038 9.04165L41.281 12.6204C41.2638 12.6817 41.2271 12.7357 41.1764 12.7742C41.1257 12.8126 41.0638 12.8335 41.0001 12.8335C40.9365 12.8335 40.8746 12.8126 40.8239 12.7742C40.7731 12.7357 40.7364 12.6817 40.7192 12.6204L39.797 9.04165Z"
        stroke="url(#paint2_linear_55748_101864)"
        strokeWidth="1.125"
        strokeLinecap="round"
        strokeLinejoin="round"
      />
    </g>
    <defs>
      <linearGradient
        id="paint0_linear_55748_101864"
        x1="13.0806"
        y1="18.6809"
        x2="30.3708"
        y2="19.1175"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#4900FF" />
        <stop offset="0.462476" stopColor="#D500FF" />
        <stop offset="1" stopColor="#FF9257" />
      </linearGradient>
      <linearGradient
        id="paint1_linear_55748_101864"
        x1="0.743715"
        y1="43.8335"
        x2="13.4812"
        y2="43.7282"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#4900FF" />
        <stop offset="0.462476" stopColor="#D500FF" />
        <stop offset="1" stopColor="#FF9257" />
      </linearGradient>
      <linearGradient
        id="paint2_linear_55748_101864"
        x1="34.7437"
        y1="12.8335"
        x2="47.4812"
        y2="12.7282"
        gradientUnits="userSpaceOnUse"
      >
        <stop stopColor="#4900FF" />
        <stop offset="0.462476" stopColor="#D500FF" />
        <stop offset="1" stopColor="#FF9257" />
      </linearGradient>
      <clipPath id="clip0_55748_101864">
        <rect width="48" height="48" fill="white" />
      </clipPath>
      <clipPath id="clip1_55748_101864">
        <rect width="14" height="14" fill="white" transform="translate(0 31)" />
      </clipPath>
    </defs>
  </svg>
);

SpaceHelmet.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
};

SpaceHelmet.defaultProps = {
  width: 48,
  height: 48,
};
